"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ComboboxSelect_component_exports = {};
__export(ComboboxSelect_component_exports, {
  UseComboboxSelectCtx: () => UseComboboxSelectCtx,
  default: () => ComboboxSelect_component_default
});
module.exports = __toCommonJS(ComboboxSelect_component_exports);
var import_react = __toESM(require("react"));
var import_react_popper = require("react-popper");
var import_useOnClickOutside = require("../../../utils/useOnClickOutside/useOnClickOutside.hook");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var import_Option = require("./Option.component");
var import_AllOptions = require("./AllOptions.component");
var import_utils = require("./utils");
var import_ComboboxSelect = require("./ComboboxSelect.styled");
var import_Helpers = require("../../../utils/Helpers");
var _excluded = ["labelWithin", "disabled", "borderLess", "darkMode", "placeholder", "multiSelect", "listBoxPlacement", "required", "error", "errorText", "selectedLabelSingular", "selectedLabelPlural", "inGlobalModal"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r))
    return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var AllOptionsType = import_react.default.createElement(import_AllOptions.AllOptions, {
  id: "test"
}).type;
var ComboboxSelectContext = /* @__PURE__ */ (0, import_react.createContext)(void 0);
var UseComboboxSelectCtx = function UseComboboxSelectCtx2() {
  var ctx = (0, import_react.useContext)(ComboboxSelectContext);
  if (!ctx)
    throw new Error("This must be used within <ComboboxSelect> component");
  return ctx;
};
var ComboboxSelect = function ComboboxSelect2(_ref) {
  var _ref$labelWithin = _ref.labelWithin, labelWithin = _ref$labelWithin === void 0 ? true : _ref$labelWithin, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$borderLess = _ref.borderLess, borderLess = _ref$borderLess === void 0 ? false : _ref$borderLess, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? "Select an option" : _ref$placeholder, _ref$multiSelect = _ref.multiSelect, multiSelect = _ref$multiSelect === void 0 ? false : _ref$multiSelect, _ref$listBoxPlacement = _ref.listBoxPlacement, listBoxPlacement = _ref$listBoxPlacement === void 0 ? "bottom" : _ref$listBoxPlacement, _ref$required = _ref.required, required = _ref$required === void 0 ? false : _ref$required, _ref$error = _ref.error, error = _ref$error === void 0 ? false : _ref$error, _ref$errorText = _ref.errorText, errorText = _ref$errorText === void 0 ? "Error" : _ref$errorText, _ref$selectedLabelSin = _ref.selectedLabelSingular, selectedLabelSingular = _ref$selectedLabelSin === void 0 ? "option" : _ref$selectedLabelSin, _ref$selectedLabelPlu = _ref.selectedLabelPlural, selectedLabelPlural = _ref$selectedLabelPlu === void 0 ? "options" : _ref$selectedLabelPlu, _ref$inGlobalModal = _ref.inGlobalModal, inGlobalModal = _ref$inGlobalModal === void 0 ? false : _ref$inGlobalModal, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(false), _useState2 = _slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
  var _useState3 = (0, import_react.useState)(props.defaultSelected !== void 0 ? props.defaultSelected : []), _useState4 = _slicedToArray(_useState3, 2), selected = _useState4[0], setSelected = _useState4[1];
  var _useState5 = (0, import_react.useState)(0), _useState6 = _slicedToArray(_useState5, 2), itemPosition = _useState6[0], setItemPosition = _useState6[1];
  var _useState7 = (0, import_react.useState)(false), _useState8 = _slicedToArray(_useState7, 2), isAllSelected = _useState8[0], setIsAllSelected = _useState8[1];
  var _useState9 = (0, import_react.useState)(null), _useState10 = _slicedToArray(_useState9, 2), optionsListNodes = _useState10[0], setOptionsListNodes = _useState10[1];
  var _useState11 = (0, import_react.useState)("All Options"), _useState12 = _slicedToArray(_useState11, 2), allSelectedLabel = _useState12[0], setAllSelectedLabel = _useState12[1];
  var _useState13 = (0, import_react.useState)(null), _useState14 = _slicedToArray(_useState13, 2), activeDescendant = _useState14[0], setActiveDescendant = _useState14[1];
  var _useState15 = (0, import_react.useState)(null), _useState16 = _slicedToArray(_useState15, 2), customSelectedValue = _useState16[0], setCustomSelectedValue = _useState16[1];
  var _useState17 = (0, import_react.useState)(), _useState18 = _slicedToArray(_useState17, 2), numberOfChildren = _useState18[0], setNumberOfChildren = _useState18[1];
  var selectComboboxRef = (0, import_react.useRef)(null);
  var optionListRef = (0, import_react.useRef)(null);
  var _useState19 = (0, import_react.useState)(true), _useState20 = _slicedToArray(_useState19, 2), firstRender = _useState20[0], setFirstRender = _useState20[1];
  var _useState21 = (0, import_react.useState)(null), _useState22 = _slicedToArray(_useState21, 2), selectableOptionsList = _useState22[0], setSelectableOptionsList = _useState22[1];
  var _useState23 = (0, import_react.useState)(null), _useState24 = _slicedToArray(_useState23, 2), coordinateCombobox = _useState24[0], setCoordinateCombobox = _useState24[1];
  var _useState25 = (0, import_react.useState)(null), _useState26 = _slicedToArray(_useState25, 2), optionListWidth = _useState26[0], setOptionListWidth = _useState26[1];
  var _useState27 = (0, import_react.useState)(null), _useState28 = _slicedToArray(_useState27, 2), optionListHeight = _useState28[0], setOptionListHeight = _useState28[1];
  var _useState29 = (0, import_react.useState)(5), _useState30 = _slicedToArray(_useState29, 2), offsetBottom = _useState30[0], setOffsetBottom = _useState30[1];
  var _usePopper = (0, import_react_popper.usePopper)(selectComboboxRef.current, optionListRef.current, {
    placement: listBoxPlacement,
    modifiers: [{
      name: "offset",
      options: {
        offset: open ? [0, offsetBottom] : [0, -2]
      }
    }]
  }), styles = _usePopper.styles, attributes = _usePopper.attributes, update = _usePopper.update;
  var isAllOptionsVariant = multiSelect && optionsListNodes && optionsListNodes.filter(function(element) {
    var _element$value;
    return ((_element$value = element.value) === null || _element$value === void 0 ? void 0 : _element$value.value) === "allOptions";
  });
  var windowInnerHeight = (0, import_Helpers.hasWindow)() ? window.innerHeight : 725;
  var getSelectedChildren = function getSelectedChildren2(index) {
    if (Array.isArray(props === null || props === void 0 ? void 0 : props.children)) {
      if (isAllOptionsVariant) {
        var childFlat = import_react.Children.toArray(props.children).flat();
        return childFlat[index];
      }
      return props.children[index];
    }
    return props === null || props === void 0 ? void 0 : props.children;
  };
  var selectAllItems = function selectAllItems2() {
    var _optionListRef$curren;
    var allItems = [];
    var options = (_optionListRef$curren = optionListRef.current) === null || _optionListRef$curren === void 0 ? void 0 : _optionListRef$curren.querySelectorAll('li[role="option"]');
    var childFlat = import_react.Children.toArray(props.children).flat();
    setIsAllSelected(!isAllSelected);
    if (isAllSelected) {
      setSelected([]);
    } else {
      for (var i = 0; i < options.length; i += 1) {
        var child = childFlat[i].props;
        if (!child.disabled) {
          if (child.value === void 0) {
            allItems.push("allOptions");
          } else {
            allItems.push(childFlat[i].props.value);
          }
        }
      }
      setSelected(allItems);
    }
  };
  var handleClick = function handleClick2() {
    if (!disabled) {
      setOpen(!open);
    }
    return false;
  };
  var listboxSelection = function listboxSelection2(currentOption) {
    var isSelected = selected.includes(currentOption.value);
    if (multiSelect) {
      if (isSelected && selected.length > 0) {
        if (isAllSelected)
          setIsAllSelected(!isAllSelected);
        setSelected((0, import_utils.filterItems)(selected, currentOption.value));
      } else {
        setSelected([].concat(_toConsumableArray(selected), [currentOption.value]));
      }
    } else if (!isSelected) {
      setSelected([currentOption.value]);
    }
  };
  var getSelectedValue = function getSelectedValue2() {
    if (multiSelect) {
      var selectedLabel = selected.length > 1 ? selectedLabelPlural : selectedLabelSingular;
      return customSelectedValue || (selected.length !== 0 ? "".concat(selected.length, " ").concat(selectedLabel, " selected") : void 0);
    }
    var _Children$toArray$fil = import_react.Children.toArray(props.children).filter(function(child) {
      if (/* @__PURE__ */ (0, import_react.isValidElement)(child)) {
        return child.props.value === selected[0];
      }
      return false;
    }), _Children$toArray$fil2 = _slicedToArray(_Children$toArray$fil, 1), selectedOptionFullInfo = _Children$toArray$fil2[0];
    if (props.handleSelection)
      return customSelectedValue;
    return /* @__PURE__ */ (0, import_react.isValidElement)(selectedOptionFullInfo) ? selectedOptionFullInfo.props.children : selected[0];
  };
  var setItemPositionAndActiveDescendant = function setItemPositionAndActiveDescendant2(options, pos) {
    setItemPosition(pos);
    setActiveDescendant(options[pos].id);
  };
  var dataContext = (0, import_react.useMemo)(function() {
    return {
      open,
      setOpen,
      id: props.id,
      selected,
      setSelected,
      itemPosition,
      setItemPosition,
      multiSelect,
      maxVisibleChars: props.maxVisibleChars,
      selectAllItems,
      isAllSelected,
      setIsAllSelected
    };
  }, [open, props.id, selected, itemPosition, multiSelect, props.maxVisibleChars, isAllSelected]);
  (0, import_react.useLayoutEffect)(function() {
    if (open) {
      if (update) {
        update();
      }
      if (firstRender) {
        setFirstRender(false);
      }
    }
  }, [open]);
  (0, import_react.useEffect)(function() {
    if (multiSelect) {
      var _optionListRef$curren2;
      var options = (_optionListRef$curren2 = optionListRef.current) === null || _optionListRef$curren2 === void 0 ? void 0 : _optionListRef$curren2.querySelectorAll('li[role="option"]');
      var optionsArr = Array.from(options, function(item) {
        return item.attributes;
      });
      setOptionsListNodes(optionsArr);
      var allOptionsCustom = import_react.Children.toArray(props.children).find(function(element) {
        return element.type === AllOptionsType;
      });
      if (allOptionsCustom)
        setAllSelectedLabel(allOptionsCustom.props.children);
      var selectable = optionsArr.filter(function(element) {
        var _element$value2;
        return ((_element$value2 = element.value) === null || _element$value2 === void 0 ? void 0 : _element$value2.value) !== "allOptions" && !element["aria-disabled"];
      });
      setSelectableOptionsList(selectable);
    }
    if (props.defaultSelected) {
      var values = import_react.Children.toArray(props.children).map(function(child) {
        return /* @__PURE__ */ (0, import_react.isValidElement)(child) ? child.props.value : null;
      });
      var validSelectedValues = props.defaultSelected.filter(function(value) {
        return values.indexOf(value) !== -1;
      });
      if (validSelectedValues.length) {
        setSelected(_toConsumableArray(validSelectedValues));
      }
    }
  }, []);
  (0, import_react.useEffect)(function() {
    if (props.onSelect && !firstRender) {
      props.onSelect(selected);
    }
    if (props.handleSelection) {
      if (multiSelect) {
        var selectedOptionsFullInfo = import_react.Children.toArray(props.children).filter(function(child) {
          if (/* @__PURE__ */ (0, import_react.isValidElement)(child)) {
            return selected.indexOf(child.props.value) !== -1;
          }
          return false;
        }).map(function(child) {
          return /* @__PURE__ */ (0, import_react.isValidElement)(child) ? child.props : null;
        });
        setCustomSelectedValue(props.handleSelection(selectedOptionsFullInfo) || null);
      } else {
        var _Children$toArray$fil3 = import_react.Children.toArray(props.children).filter(function(child) {
          if (/* @__PURE__ */ (0, import_react.isValidElement)(child)) {
            return child.props.value === selected[0];
          }
          return false;
        }), _Children$toArray$fil4 = _slicedToArray(_Children$toArray$fil3, 1), selectedOptionFullInfo = _Children$toArray$fil4[0];
        setCustomSelectedValue(/* @__PURE__ */ (0, import_react.isValidElement)(selectedOptionFullInfo) ? props.handleSelection(selectedOptionFullInfo.props) : null);
      }
    }
    if ((isAllOptionsVariant === null || isAllOptionsVariant === void 0 ? void 0 : isAllOptionsVariant.length) > 0 && selected.length === (selectableOptionsList === null || selectableOptionsList === void 0 ? void 0 : selectableOptionsList.length)) {
      setIsAllSelected(true);
      setSelected([].concat(_toConsumableArray(selected), ["allOptions"]));
    }
  }, [selected]);
  (0, import_react.useEffect)(function() {
    if (props.defaultSelected && Array.isArray(props.defaultSelected) && (selected.length !== props.defaultSelected.length || JSON.stringify(selected) !== JSON.stringify(props.defaultSelected))) {
      setSelected(props.defaultSelected);
    }
  }, [props.defaultSelected]);
  (0, import_react.useEffect)(function() {
    var _optionListRef$curren3;
    var options = (_optionListRef$curren3 = optionListRef.current) === null || _optionListRef$curren3 === void 0 ? void 0 : _optionListRef$curren3.querySelectorAll('li[role="option"]');
    var optionsArr = Array.from(options, function(item) {
      return item.attributes;
    });
    setNumberOfChildren(optionsArr.length);
  });
  (0, import_react.useEffect)(function() {
    if (multiSelect && isAllOptionsVariant) {
      var _optionListRef$curren4;
      var options = (_optionListRef$curren4 = optionListRef.current) === null || _optionListRef$curren4 === void 0 ? void 0 : _optionListRef$curren4.querySelectorAll('li[role="option"]');
      var optionsArr = Array.from(options, function(item) {
        return item.attributes;
      });
      var selectable = optionsArr.filter(function(element) {
        var _element$value3;
        return ((_element$value3 = element.value) === null || _element$value3 === void 0 ? void 0 : _element$value3.value) !== "allOptions" && !element["aria-disabled"];
      });
      setSelectableOptionsList(selectable);
      var newSelected = selected.filter(function(elem) {
        return elem !== "allOptions";
      });
      setSelected(newSelected);
      setIsAllSelected(false);
    }
  }, [numberOfChildren]);
  (0, import_useOnClickOutside.useOnClickOutside)(selectComboboxRef, function() {
    setOpen(false);
    setActiveDescendant(null);
  });
  (0, import_useOnKeydown.useOnKeydown)(selectComboboxRef, function(keyList, ev) {
    var _optionListRef$curren5;
    var Enter = keyList.Enter, Space = keyList[" "], ArrowUp = keyList.ArrowUp, ArrowDown = keyList.ArrowDown, Home = keyList.Home, End = keyList.End, Escape = keyList.Escape, Tab = keyList.Tab;
    var options = (_optionListRef$curren5 = optionListRef.current) === null || _optionListRef$curren5 === void 0 ? void 0 : _optionListRef$curren5.querySelectorAll('li[role="option"]');
    if (Enter || Space) {
      var _optionListRef$curren6, _optionListRef$curren7;
      ev.preventDefault();
      var selectedOption = (_optionListRef$curren6 = optionListRef.current) === null || _optionListRef$curren6 === void 0 ? void 0 : _optionListRef$curren6.querySelector('li[aria-selected="true"]');
      if (!disabled) {
        setOpen(!open);
      }
      if (selectedOption) {
        var pos = Number(selectedOption.dataset.navId);
        setItemPositionAndActiveDescendant(options, pos);
        (0, import_utils.defineScrollBehavior)(optionListRef.current, options, pos);
      } else {
        setItemPositionAndActiveDescendant(options, 0);
        (0, import_utils.defineScrollBehavior)(optionListRef.current, options, 0);
      }
      (_optionListRef$curren7 = optionListRef.current) === null || _optionListRef$curren7 === void 0 || _optionListRef$curren7.focus();
      ev.stopPropagation();
    }
    if (Tab) {
      setOpen(false);
    }
    if (!disabled) {
      if (ArrowDown || Home) {
        var _optionListRef$curren8;
        setOpen(true);
        setItemPositionAndActiveDescendant(options, 0);
        (_optionListRef$curren8 = optionListRef.current) === null || _optionListRef$curren8 === void 0 || _optionListRef$curren8.focus();
      }
      if (ArrowUp || End) {
        var _optionListRef$curren9;
        setOpen(true);
        setItemPositionAndActiveDescendant(options, options.length - 1);
        (0, import_utils.defineScrollBehavior)(optionListRef.current, options, options.length - 1);
        (_optionListRef$curren9 = optionListRef.current) === null || _optionListRef$curren9 === void 0 || _optionListRef$curren9.focus();
      }
    }
    if (Escape) {
      if (open)
        ev.stopPropagation();
      setOpen(false);
      setActiveDescendant(null);
      selectComboboxRef.current.focus();
    }
  });
  (0, import_useOnKeydown.useOnKeydown)(optionListRef, function(keyList, ev) {
    var ArrowDown = keyList.ArrowDown, ArrowUp = keyList.ArrowUp, Home = keyList.Home, End = keyList.End, Enter = keyList.Enter, Escape = keyList.Escape, Tab = keyList.Tab, Space = keyList[" "], a = keyList.a, Shift = keyList.Shift;
    var options = optionListRef.current.querySelectorAll('li[role="option"]');
    var pos;
    var currentOption;
    var optionArr = [];
    var positionedOption;
    var isSelected;
    var selectedCopy = [];
    if (Space || Enter) {
      ev.preventDefault();
      if (!getSelectedChildren(itemPosition).props.disabled) {
        currentOption = getSelectedChildren(itemPosition).props;
        listboxSelection(currentOption);
        if (!multiSelect) {
          setOpen(false);
          selectComboboxRef.current.focus();
        }
      }
    }
    if (Tab) {
      setOpen(false);
    }
    if (ArrowUp && !ev.shiftKey) {
      pos = itemPosition - 1 >= 0 ? itemPosition - 1 : options.length - 1;
      setItemPositionAndActiveDescendant(options, pos);
      (0, import_utils.defineScrollBehavior)(optionListRef.current, options, pos);
    }
    if (ArrowDown && !ev.shiftKey) {
      pos = itemPosition === options.length - 1 ? 0 : itemPosition + 1;
      setItemPositionAndActiveDescendant(options, pos);
      (0, import_utils.defineScrollBehavior)(optionListRef.current, options, pos);
    }
    if (Home) {
      setItemPositionAndActiveDescendant(options, 0);
      (0, import_utils.defineScrollBehavior)(optionListRef.current, options, 0);
    }
    if (End) {
      setItemPositionAndActiveDescendant(options, options.length - 1);
      (0, import_utils.defineScrollBehavior)(optionListRef.current, options, options.length - 1);
    }
    if (Escape) {
      setOpen(false);
      setActiveDescendant(null);
      selectComboboxRef.current.focus();
      ev.stopPropagation();
    }
    if (multiSelect) {
      if ((Space || Enter) && !getSelectedChildren(itemPosition).props.disabled) {
        ev.preventDefault();
        currentOption = getSelectedChildren(itemPosition).props;
        if (currentOption.value === void 0) {
          selectAllItems();
        } else {
          listboxSelection(currentOption);
        }
        (0, import_utils.defineScrollBehavior)(optionListRef.current, options, itemPosition);
      }
      if (ev.shiftKey && (ArrowDown || ArrowUp)) {
        selectedCopy = _toConsumableArray(selected);
        if (Shift) {
          setSelected([]);
          selectedCopy = [];
        }
        optionArr = [];
        if (ArrowDown) {
          pos = itemPosition === options.length - 1 ? itemPosition : itemPosition + 1;
        } else if (ArrowUp) {
          pos = itemPosition - 1 >= 0 ? itemPosition - 1 : itemPosition;
        }
        positionedOption = getSelectedChildren(itemPosition).props;
        isSelected = selectedCopy.includes(positionedOption.value);
        if (!positionedOption.disabled && !isSelected) {
          optionArr.push(positionedOption.value);
        }
        setItemPositionAndActiveDescendant(options, pos);
        (0, import_utils.defineScrollBehavior)(optionListRef.current, options, pos);
        currentOption = props.children[pos].props;
        var hasAlreadySelected = selectedCopy.includes(currentOption.value);
        if (positionedOption.value !== currentOption.value && !currentOption.disabled && !hasAlreadySelected) {
          optionArr.push(currentOption.value);
        }
        setSelected([].concat(_toConsumableArray(selectedCopy), _toConsumableArray(optionArr)));
      }
      if (ev.ctrlKey && a || ev.metaKey && a) {
        ev.preventDefault();
        var allItems = [];
        setIsAllSelected(!isAllSelected);
        if (isAllSelected) {
          setSelected([]);
        } else {
          for (var i = 0; i < options.length; i += 1) {
            if (!props.children[i].props.disabled)
              allItems.push(props.children[i].props.value);
          }
          setSelected(allItems);
        }
      }
      if (ev.shiftKey && ev.ctrlKey && Home) {
        var _allItems = [];
        for (var _i = 0; _i <= itemPosition; _i += 1) {
          if (!props.children[_i].props.disabled)
            _allItems.push(props.children[_i].props.value);
        }
        setSelected(_allItems);
      }
      if (ev.shiftKey && ev.ctrlKey && End) {
        var _allItems2 = [];
        for (var _i2 = itemPosition; _i2 < options.length; _i2 += 1) {
          if (!props.children[_i2].props.disabled)
            _allItems2.push(props.children[_i2].props.value);
        }
        setSelected(_allItems2);
      }
    }
    ev.stopPropagation();
  });
  var handleBlur = function handleBlur2(event) {
    event.stopPropagation();
    setTimeout(function() {
      if (document.activeElement !== optionListRef.current) {
        if (props.onBlur) {
          props.onBlur();
        }
      }
    }, 100);
  };
  (0, import_react.useEffect)(function() {
    var _selectComboboxRef$cu;
    var inputElementRect = (_selectComboboxRef$cu = selectComboboxRef.current) === null || _selectComboboxRef$cu === void 0 ? void 0 : _selectComboboxRef$cu.getBoundingClientRect();
    setCoordinateCombobox(inputElementRect);
  }, [windowInnerHeight]);
  (0, import_react.useEffect)(function() {
    if (open && inGlobalModal && (0, import_Helpers.hasWindow)()) {
      var minMargin = 20;
      var value = Math.trunc(window.innerHeight - coordinateCombobox.bottom - minMargin);
      setOffsetBottom(-window.scrollY);
      setOptionListHeight(value);
      setOptionListWidth(selectComboboxRef.current.offsetWidth);
      if (update) {
        update();
      }
    }
    if (!open) {
      setOptionListHeight(null);
    }
  }, [open, coordinateCombobox]);
  var handleFocus = function handleFocus2() {
    return props.onFocus && props.onFocus();
  };
  return /* @__PURE__ */ import_react.default.createElement(ComboboxSelectContext.Provider, {
    value: dataContext
  }, /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledComboboxContainer, null, /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledLayoutContainer, {
    "data-testid": "combobox-select-container",
    className: props.className
  }, !labelWithin && /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledLabel, {
    darkMode,
    id: (0, import_utils.computedId)("label", props.id),
    className: "select__label",
    title: props.label
  }, props.label, required && /* @__PURE__ */ import_react.default.createElement("span", {
    "aria-hidden": true
  }, "*")), /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledCombobox, {
    "aria-controls": (0, import_utils.computedId)("list", props.id),
    "aria-disabled": disabled,
    "aria-expanded": open,
    "aria-haspopup": "listbox",
    "aria-labelledby": (0, import_utils.computedId)("label", props.id),
    "aria-describedby": (0, import_utils.computedId)("error", props.id),
    borderLess,
    className: "select__combobox",
    darkMode,
    isDisabled: disabled,
    error,
    id: (0, import_utils.computedId)("combobox", props.id),
    labelWithin,
    onClick: handleClick,
    role: "combobox",
    tabIndex: 0,
    ref: selectComboboxRef,
    "data-testid": "combobox-select-combo",
    "aria-required": required && true,
    onBlur: handleBlur,
    onFocus: handleFocus,
    "aria-label": !props.label ? "Select an option" : null
  }, /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledComboboxLayout, {
    className: "select__combobox-layout"
  }, /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledComboboxIconContainer, {
    className: "select__combobox-layout-icon-container"
  }, props.comboboxIcon && /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
    icon: props.comboboxIcon,
    size: 18
  })), /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledComboboxContent, null, labelWithin && /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledLabel, {
    id: (0, import_utils.computedId)("label", props.id),
    className: "select__label",
    darkMode,
    labelWithin,
    error,
    disabled
  }, props.label, required && /* @__PURE__ */ import_react.default.createElement("span", {
    "aria-hidden": true
  }, "*")), selected[0] ? /* @__PURE__ */ import_react.default.createElement("span", {
    className: "select__combobox-layout-selected"
  }, isAllSelected && (isAllOptionsVariant === null || isAllOptionsVariant === void 0 ? void 0 : isAllOptionsVariant.length) > 0 ? allSelectedLabel : getSelectedValue()) : /* @__PURE__ */ import_react.default.createElement("span", {
    className: "select__combobox-layout-placeholder"
  }, placeholder)), /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledComboboxIconContainer, {
    className: "select__combobox-layout-icon-container"
  }, /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
    icon: open ? "chevron-up" : "chevron-down",
    size: 20,
    color: import_baseTheme.default.colors.pr.base
  }))), /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledOptionsList, _extends({
    "aria-activedescendant": activeDescendant,
    "aria-labelledby": (0, import_utils.computedId)("label", props.id),
    className: "select__list",
    id: (0, import_utils.computedId)("list", props.id),
    labelWithin,
    role: "listbox",
    ref: optionListRef,
    tabIndex: -1,
    isOpen: open,
    inGlobalModal,
    style: styles.popper,
    onBlur: function onBlur(e) {
      return e.stopPropagation();
    },
    onFocus: function onFocus(e) {
      return e.stopPropagation();
    },
    optionListWidth,
    optionListHeight
  }, attributes.popper), import_react.Children.map(props.children, function(child, idx) {
    if (/* @__PURE__ */ (0, import_react.isValidElement)(child)) {
      return /* @__PURE__ */ (0, import_react.cloneElement)(child, {
        navId: idx,
        // dataDpAnalyticsId: child.props.dataDpAnalyticsId || child.props.id,
        // dataDpAnalyticsExternalId: child.props.dataDpAnalyticsExternalId,
        selectComboboxRef
      });
    }
    return child;
  })))), /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledErrorContainer, {
    darkMode,
    "aria-live": "assertive",
    id: (0, import_utils.computedId)("error", props.id)
  }, error && errorText && /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_ComboboxSelect.StyledIcon, {
    icon: "warning",
    ariaHidden: true
  }), /* @__PURE__ */ import_react.default.createElement("span", null, errorText)))));
};
ComboboxSelect.Option = import_Option.Option;
ComboboxSelect.AllOptions = import_AllOptions.AllOptions;
var ComboboxSelect_component_default = ComboboxSelect;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  UseComboboxSelectCtx
});
//# sourceMappingURL=ComboboxSelect.component.js.map